import { ROSARY_PRAYERS } from "@/data/rosary";
import { rosaryUI } from "@/data/rosaryLocale";
import { PrayerAudio } from "@/components/prayers/PrayerAudio";

export const RosaryPrayer = ({ prayerKey, lang, showTitle = true, prefix = "reader" }) => {
  const prayer = ROSARY_PRAYERS[prayerKey];
  return (
    <div>
      {showTitle && <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold" data-testid={`${prefix}-prayer-title`}>{prayer.titles[lang]}</p>}
      <p className="mt-4 whitespace-pre-line font-serif text-base leading-relaxed text-midnight sm:text-lg" lang={lang} data-testid={`${prefix}-prayer-text`}>{prayer[lang]}</p>
      <a data-testid={`${prefix}-prayer-source`} href={prayer.sourceUrl} target="_blank" rel="noreferrer" className="mt-4 inline-block text-xs text-marian underline">{prayer.sourceLabel}</a>
      <PrayerAudio prayerId={prayerKey} prefix={prefix} lang={lang} />
      {lang !== "en" && (
        <details className="mt-4" data-testid={`${prefix}-english-translation`}>
          <summary className="cursor-pointer font-mono text-[10px] uppercase tracking-[0.2em] text-slateblue hover:text-marian" data-testid={`${prefix}-show-english`}>{rosaryUI(lang).showEnglish}</summary>
          <p className="mt-3 whitespace-pre-line text-sm leading-relaxed text-charcoal/80" lang="en" data-testid={`${prefix}-english-text`}>{prayer.en}</p>
        </details>
      )}
    </div>
  );
};

export const MysteryText = ({ mystery, lang, prefix = "reader" }) => {
  const t = rosaryUI(lang);
  return (
    <div data-testid={`${prefix}-mystery-text`}>
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">{t.announce}</p>
      <p className="mt-2 font-serif text-2xl font-semibold text-midnight sm:text-3xl" data-testid={`${prefix}-mystery-title`}>{mystery.title}</p>
      <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.15em] text-gold">{t.meaning}</p>
      <p className="mt-2 text-sm leading-relaxed text-charcoal/90" data-testid={`${prefix}-mystery-meaning`}>{mystery.meaning}</p>
      <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.15em] text-gold">Scripture meditation · RSV-CE · English</p>
      <p className="mt-4 font-serif text-lg italic leading-relaxed text-charcoal/90" data-testid={`${prefix}-mystery-verse`}>{mystery.verse}</p>
      <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slateblue" data-testid={`${prefix}-mystery-reference`}>{mystery.ref}</p>
      {mystery.scriptureSource && <a href={mystery.scriptureSource} target="_blank" rel="noreferrer" data-testid={`${prefix}-scripture-source`} className="mt-3 inline-block text-xs text-marian underline">RSV-CE · English source</a>}
      <p className="mt-6 text-sm text-charcoal/85" data-testid={`${prefix}-mystery-meditation`}>{t.meditate} — <span className="font-semibold">{mystery.fruit.toLowerCase()}</span>.</p>
    </div>
  );
};